import styled from 'styled-components';

export const SignupFormContainer = styled.div`
  width: ${props => props.width};
  height: ${props => props.height};
  background: ${props => props.backgroundColor};
  box-shadow: ${props => (props.shadow ? 'rgba(160,161,188,.35)' : 'none')};

  .signup-form--form {
    .data-layer-form {
      padding: 33px 40px 0;
    }

    .ant-form-item {
      button {
        margin-top: 8px;
      }
    }

    .ant-select {
      padding: 0 9px 0 9px;
    }

    .ant-progress {
      width: 100%;
    }

    .ant-progress-steps-item {
      min-width: calc(20% - 8px);
      margin-right: 8px;
      height: 6px;
    }

    .radio-field-wrapper {
      flex-direction: row;
      flex-wrap: wrap;
      height: inherit;
    }

    .radio-div {
      width: 100%;
      height: auto;
      margin: 9px;
      color: var(--normal-title-color);
      float: none;
      flex: 45%;

      &:last-child label {
        border-left: 1px solid #cfd8dc;
      }

      &.selected:last-child label {
        border-left: 3px solid var(--input-selected-color);
      }

      &.selected label {
        border-width: 3px;
      }

      label {
        padding: 24px 16px 24px 16px;
        line-height: 30px;
        font-size: 20px;
        font-weight: normal;
      }
    }

    .radio-field-error .radio-div > label {
      border-left: 3px solid red;
    }

    .st-slider-field--helper {
      width: 20px;
      height: 20px;
      min-width: 20px;
      min-height: 20px;
      display: inline-block;
      border-radius: 50%;
      background: var(--blue-6);
      font-weight: bold;
      font-size: 13px;
      line-height: 22px;
      text-align: center;
      color: var(--white-color);
      margin-left: 10px;
      cursor: pointer;
      vertical-align: top;
    }

    .signup-form--title {
      text-align: center;
      font-size: 1.9rem;
      padding: 0 0 0 0;
      line-height: 37px;
    }

    .ant-row:nth-of-type(n + 2) .signup-form--title {
      margin-top: 10px;
    }

    .signup-form--description-normal {
      display: none;
      font-weight: 500;
      font-size: 16px;
      line-height: 150%;
      letter-spacing: 0;
      color: var(--normal-description-color);
      text-align: center;
      margin: 10px 0 20px 0;
    }

    .signup-form--description-tooltip {
      margin-top: 7px;
    }

    .signup-form--progress {
      width: 100%;
      padding: 0 40px 33px;
      margin: 0 auto;
    }

    .signup-form--footer {
      font-family: 'Sofia Pro';
      padding: 0 40px 33px;
    }

    .signup-form--footer-1 {
      font-size: 16px;
      font-weight: 300;
      line-height: 26px;
      color: gray;
      padding: 0 40px 33px;

      & > a {
        color: gray;
        text-decoration: underline;
      }
    }

    .slick-prev {
      left: 5px;
      position: relative;
      z-index: 10;
      top: 14px;

      &:before {
        border: solid black;
        border-width: 0 3px 3px 0;
        display: inline-block;
        padding: 9px;
        content: '';
        transform: rotate(135deg);
        -webkit-transform: rotate(135deg);
      }
    }
  }

  @media (max-width: 768px) {
    .signup-form--form {
      .data-layer-form {
        padding: 24px 16px 0;
      }

      .signup-form--footer,
      .signup-form--footer-1,
      .signup-form--progress {
        padding: 0 16px 24px;
      }

      .ant-form-item {
        button {
          margin-top: 0;
        }
      }

      .ant-select {
        padding: 0 5px 0 5px;
      }

      .signup-form--title {
        font-size: 20px;
        line-height: 120%;
      }

      .signup-form--footer,
      .signup-form--footer-1 {
        font-size: 14px !important;
      }

      .signup-form--description-tooltip {
        margin-top: 2px;
      }
    }
  }

  @media (max-width: 576px) {
    .signup-form--form {
      .data-layer-form {
        padding: 20px 24px 0;
      }

      .signup-form--footer,
      .signup-form--footer-1,
      .signup-form--progress {
        padding: 0 24px 20px;
      }

      .signup-form--title {
        margin-right: inherit;
      }

      .signup-form--submit-button {
        padding: 12px 24px;
        font-size: 16px;
      }

      .radio-div {
        flex: 40%;
        margin: 5px;

        label {
          font-size: 16px;
          padding: 20px 8px 20px 8px;
        }
      }

      .section-demo-hero--mobile-form-content {
        overflow: auto;
      }
    }
  }

  .signup-form--step1 {
    .signup-form--title {
      text-align: left;
      padding-bottom: 24px;
    }
  }

  &.demo-form-style--5 {
    .signup-form--step1 {
      background: var(--blue-primary);

      .signup-form--title {
        color: var(--white-color);
      }
    }

    .signup-form--description-tooltip {
      display: none;
    }

    .signup-form--description-normal {
      display: block;
    }

    .signup-form--footer {
      background: var(--blue-primary);
      font-size: 16px;
      font-weight: 300;
      line-height: 26px;
      color: #fff;
      text-align: center;
      & > a {
        color: #fff;
        text-decoration: underline;
      }
    }

    .signup-form--footer-1 {
      display: none;
    }

    .signup-form--progress {
      width: 90%;
    }

    .signup-form--submit-button-final {
      margin: 15px calc(15% + 8px);
      width: calc(70% - 16px);
    }

    .radio-div {
      height: 90px;
      flex: 30%;
    }

    .radio-field-wrapper {
      margin-top: 20px;
    }

    #officeStaffNumber,
    #areaOfFocus,
    #typeOfBusiness {
      padding: 0 15%;

      .radio-div {
        flex: 45%;
      }
    }

    @media (max-width: 576px) {
      .radio-div {
        flex: 45%;
        height: auto;
      }

      .signup-form--footer {
        text-align: left;
      }

      .signup-form--progress {
        width: 100%;
      }

      #officeStaffNumber,
      #areaOfFocus,
      #typeOfBusiness {
        padding: 0;
      }

      .signup-form--submit-button-final {
        margin: 15px 0;
        width: 100%;
      }
    }
  }
`;

export const StepContainer = styled.div`
  min-height: 600px;

  @media (max-width: 576px) {
    min-height: 400px;
  }
`;

export const FormTitle = styled.p`
  font-family: Sofia Pro;
  font-size: 36px;
  font-weight: 600;
  line-height: 43px;
  letter-spacing: -0.04em;
  color: ${props => props.titleColor};
  padding: 0;
  margin: 0 0 24px;
  margin-bottom: 8px;

  @media (max-width: 576px) {
    font-size: 28px;
    line-height: 26px;
  }
`;
